import { gql } from '@apollo/client';
/**
 * @fragment LocationPhoneFragment
 * @since 1.0.0
 */
export const LocationPhoneFragment = gql `
  fragment LocationPhoneFragment on LocationPhone {
    id
    type
    phone
    extension
    primary
    createdAt
    updatedAt
  }
`;
